import { Link } from "react-router-dom";

export default function SubscribeCta() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20">
      <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-12 md:px-14 md:py-16">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-300/40 blur-2xl"></div>
        <div className="pointer-events-none absolute -bottom-20 left-1/3 h-52 w-52 rounded-full bg-accent-400/30 blur-2xl"></div>

        <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
          <div className="max-w-2xl">
            <p className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-3.5 py-1.5 text-xs font-medium text-background-50">
              <i className="ri-mail-star-line"></i>
              每周一次，不打扰
            </p>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              订阅本周瓜单，周末一次看完
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-100 md:text-base">
              每周瓜单更新后，我们会把当周最重要的焦点事件与脉络梳理汇总成一份邮件，只保留真正值得一看的内容。
            </p>
          </div>
          <Link
            to="/about#subscribe"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            <i className="ri-send-plane-line"></i>
            立即订阅瓜单
          </Link>
        </div>
      </div>
    </section>
  );
}